import React from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Layout from '../../NewHeader/Layout';
import './OrderList.css';
import { var_api,image_api } from '../../constant';
import slotimg from "../../../images/shawarma/sh1.png"
import slotimg1 from "../../../images/sandwich/s2.png"
import slotimg2 from "../../../images/lunch/lunch3.png"
import DefaultProfileImage from '../../../images/profile.png';
import DefaultProfileImages from '../../../images/burger/b2.png';
import Pagination from 'react-js-pagination';
import profile from '../../../images/splash/avatar.png';


const OrderList = () => {
  const history = useHistory();
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const formatDates = (date) => {
    // Convert DD-MM-YYYY to YYYY-MM-DD
    const [day, month, year] = date.split("-");
    return `${year}-${month}-${day}`;
  };
  // const formatDateForInput = (date) => {
  //   const year = date.getFullYear();
  //   const month = String(date.getMonth() + 1).padStart(2, "0");
  //   const day = String(date.getDate()).padStart(2, "0");
  //   return `${year}-${month}-${day}`; // YYYY-MM-DD format
  // };

  const [show, setShow]  = useState(false);
  const [tables, setTables] = useState([]);
  const [ListData, setListData] = useState([]);
  const [PopupData, setPopupData] = useState([]);

  
  const [shops, setShops] = useState([]);
  const [selectedShop, setSelectedShop] = useState(null);
  const [ searchQuery,setSearchQuery] = useState('');
  const [ isEdit,setIsEdit ] = useState(false);
  const [ isCreate,setCreate ] = useState(false);

  const [ loading, setLoading ] = useState(false);
  const [ postloading,setPostLoading ] = useState(false);
  const [selectedDate, setSelectedDate] = useState(formatDate(new Date())); // Initialize with the current date
  const [selectedId, setSelectedId] = useState(null);
  const [bookingOrder, setBookingorders] = useState([]);
  const [ itempopup, setItempopup ] = useState(false);
  const [ orderNo, setOrderNo ] = useState('');
  const [ updateId, setupdateId ] = useState('');
  const [ orderedItems, setorderItems ] = useState([]);
  const [ setOrdereditempopup, setOrderedItempopup ] = useState(false);
  
  const [EmployeeD, setEmployeeD] = useState({});
  const [formData, setFormData] = useState({
    e_name: "", 
    e_email: null, 
    e_password: null,
    e_phone: null,
    e_role: "",
    profile: null,
    shops: [],
    user_id: localStorage.getItem("userId")
});
const [updateformData, setUpdateFormData] = useState({
  id:null,
  e_name: "", 
  e_email: null, 
  e_password: null,
  e_phone: null,
  e_role: "",
  profile: null,
  shops: []
});

const itemsList = [
    { name: "Item 1", qty: 2, unitPrice: 100, image:slotimg },
    { name: "Item 2", qty: 5, unitPrice: 200, image:slotimg1},
    { name: "Item 3", qty: 1, unitPrice: 150, image:slotimg2 },
    // Add more items as needed
  ];


console.log(formData)


useEffect(() => {
  fetchTables();
}, []);

useEffect(() => {
  if (tables.length > 0) {
    // Set initial values for dropdown and date on mount
    setSelectedId(tables[0]?.customer_id);
    fetchList(tables[0]?.customer_id, selectedDate);
  }
}, [tables]);


      const fetchTables = async () => {
        const shop_id = localStorage.getItem('ShopId');
        const token = localStorage.getItem('Token');
    
        try {
          const response = await axios.get(
            `${var_api}credit-user-request/active-shop-customers/${shop_id}`,
            {
              headers: {
                Authorization: `${token}`, // Add the token to the Authorization header dynamically
              },
            }
          );
          console.log("Response received:", response);
          const user = response.data.data;
          setTables(user);
        } catch (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
        }
      };
      

      const fetchList = async (id, date) => {
        const shop_id = localStorage.getItem("ShopId");
        const token = localStorage.getItem("Token");
    
        try {
          const response = await axios.get(
            `${var_api}booking-orders/credit-order-history/${shop_id}/${date}/${id}`,
            {
              headers: {
                Authorization: `${token}`, // Add the token to the Authorization header dynamically
              },
            }
          );
          setListData(response.data.data);
          console.log("Response received:", response);
        } catch (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error fetching data:", error);
          }
        }
      };
    
      const handleDateChange = (event) => {
        const newDate = formatDate(new Date(event.target.value));
        setSelectedDate(newDate);
        fetchList(selectedId, newDate);
      };
    
      const handleDropdownChange = (event) => {
        const newId = event.target.options[event.target.selectedIndex].getAttribute(
          "data-id"
        );
        setSelectedId(newId);
        fetchList(newId, selectedDate);
      };
    




  // Function to capitalize the first letter of a string
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
   };
  
   const getStatusDetails = (status) => {
    switch (status) {
      case 1:
        return { text: "Approved", color: "green" };
      case 2:
        return { text: "Cancelled", color: "red" };
      default:
        return { text: "New", color: "blue" };
    }
  };
      //post the form data
    const Submit = async (e) => {
      e.preventDefault();
      setPostLoading(true);

      try {

        const camelCaseEName = capitalize(formData.e_name);

        const formDataToSend = new FormData();
        // Append all form fields to the FormData object
        formDataToSend.append('e_name', camelCaseEName);
        formDataToSend.append('e_email', formData.e_email);
        formDataToSend.append('e_password', formData.e_password);
        formDataToSend.append('e_phone', formData.e_phone);
        formDataToSend.append('e_role', formData.e_role);
        formDataToSend.append('profile', formData.profile);
        formDataToSend.append('user_id', formData.user_id);
    
        // Append shop data (if any)
        formData.shops.forEach((shop, index) => {
          formDataToSend.append(`shops[${index}][shop_name]`, shop.shop_name);
          formDataToSend.append(`shops[${index}][shop_id]`, shop.shop_id);
          formDataToSend.append(`shops[${index}][is_active]`, shop.is_active);
        });
        

        const response = await axios.post(`${var_api}/api/employees/post`, formDataToSend, {
            headers: {
                'Content-Type': 'multipart/form-data' // Set content type to multipart/form-data
            }
        });
        const result = response.data;
        console.log("rrrr",result);
        if(result.message === "Employee created successfully"){
          setCreate(false);
          fetchTables();
          setPostLoading(false)
          Swal.fire({
            icon:"success",
            text:'Employee Created Successfully',
            confirmButtonColor:"#007500"
          })

          setFormData({...formData,
            e_name: "", 
            e_email: " ", 
            e_password: "",
            e_phone: "",
            e_role: "",
            profile: " "
          })
          

        }
        // Handle successful response (e.g., show a success message to the user)
      } catch (error) {
        // Handle request failure
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      setPostLoading(false)

      console.error('Server responded with error status:', error.response.status);
      if (error.response.data && error.response.data.message) {
        setPostLoading(false)
       
        Swal.fire({
          icon:"error",
          text: error.response.data.message,
          confirmButtonColor:"#007500"
        })
      } else {
        alert('An error occurred. Please try again later.');
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('No response received from the server:', error.request);
      setPostLoading(false)
      alert('No response received from the server. Please try again later.');
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error occurred while setting up the request:', error.message);
      setPostLoading(false)
      alert('An error occurred. Please try again later.');
    }
        
      }
    };


      

     //delete method for remove UOM
   
    const handleItempopup = () => {
        setItempopup(true);
        }


    //delete the employeee
    const handleDelete = () => {
      axios
      .delete(`${var_api}/api/employees/emp-delete/${EmployeeD.id}`)
      .then((response) => {
        if (response.status === 200) {
          fetchTables();
          setShow(false);
          Swal.fire("success"," Employee Removed Successfully!","success")
          // Perform any other actions you need on success
        } else if (response.status === 404) {
          console.log('Table not found');
          Swal.fire("error","Employee not found!","error")
        }
      })
      .catch((error) => {
        console.error('Error executing the request:', error);
        Swal.fire("error","Failed to Remove Employee!","error")
        // Handle the error as needed
      });
    }

    const openPopup = (e) =>{
      setItempopup(true);
      setPopupData(e);
    }

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); // Number of items per page
    const [searchTerm, setSearchTerm] = useState('');
  
    // Filtering tables based on search term
    const filteredTables = ListData.filter((item) => {
      // Map status, payment status, and order type to readable text
      const approvalStatusText = (() => {
        switch (item.approval_status) {
          case 1:
            return "Approved";
          case 2:
            return "Cancelled";
          default:
            return "New";
        }
      })();
    
      const paymentStatusText = item.payment_status === 0 ? "Not Paid" : "Paid";
    
      const orderTypeText =
        item.order_type === 1
          ? "Normal Order"
          : item.order_type === 2
          ? "Credit Order"
          : "-";
    
      const slotType =
        item.slot_type === 0
          ? "Single Slot"
          : item.slot_type === 1
          ? "Multi-slot"
          : "-";
    
      const refund =
        item.is_refund === 1
          ? "Refunded"
          : item.slot_type === 1
          ? "Not Refunded"
          : "-";
    
      const safeString = (value) => (value ? String(value).toLowerCase() : ""); // Safely handle undefined values
    
      return (
        safeString(item.customer_name).includes(searchTerm.toLowerCase()) ||
        safeString(item.mobile_no).includes(searchTerm.toLowerCase()) ||
        safeString(item.order_no).includes(searchTerm.toLowerCase()) ||
        safeString(item.delivery_address).includes(searchTerm.toLowerCase()) ||
        safeString(item.slot_name).includes(searchTerm.toLowerCase()) ||
        safeString(item.delivery_date).includes(searchTerm.toLowerCase()) ||
        safeString(item.amount).includes(searchTerm.toLowerCase()) ||
        safeString(item.delivered_address).includes(searchTerm.toLowerCase()) ||
        safeString(item.delivered_time).includes(searchTerm.toLowerCase()) ||
        safeString(slotType).includes(searchTerm.toLowerCase()) ||
        safeString(approvalStatusText).includes(searchTerm.toLowerCase()) ||
        safeString(paymentStatusText).includes(searchTerm.toLowerCase()) ||
        safeString(orderTypeText).includes(searchTerm.toLowerCase()) ||
        safeString(refund).includes(searchTerm.toLowerCase())
      );
    });
    
    
    
  
    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = filteredTables.length;
  
    const handleSearchInput = (event) => {
      setSearchTerm(event.target.value);
      setCurrentPage(1); // Reset to the first page when search changes
    };
  
    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
    };

    const handleshow =(data,dataId)=>{
      setBookingorders(data);
      setItempopup(true);
      localStorage.setItem('SelectedBookingId', dataId);
    }

    const handelOrderNo =(data)=>{
      setOrderNo(data.order_no);
      setupdateId(data.id);
      console.log(orderNo +'---'+updateId)
    }


    const handleshowItems =(data)=>{
      setorderItems(data);
      setOrderedItempopup(true);
    }
    
    

    return(
      <>         <Layout>

 

            <div class="splitol">
          
      <div style={{border:"none",padding:"20px",width:"100%",height:"auto",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>    
    {/* <Button variant='dark'className='mb-4' onClick={handleCreateEmployee}   style={{fontSize:"18px",float:"right",borderRadius:"15px"}}>Create Blocked Slot</Button>{' '} */}
    
    <div>
  
   
     <div className='d-flex justify-content-between'>
       <div >
       <h4 className='ushe'>CREDIT ORDER HISTORY</h4>
       </div>
       <div>
       <select
        className="itSelect m-0 p-0 mb-2"
        aria-label="Default select example"
        required
        onChange={handleDropdownChange}
      >
        {tables.map((names) => (
          <option
            value={names.customer_name}
            key={names.customer_id}
            data-id={names.customer_id}
          >
            {names.customer_name}
          </option>
        ))}
      </select>
       </div>
       <div  className='d-flex justify-content-between'>
        <div className='me-3  mb-2'>
       <input
        className="form-control mb-2"
        type="date"
        placeholder="Search"
        id="example-search-input"
        style={{
          width: "230px",
          borderRadius: "10px",
          border: "1px solid black",
          float: "right",
        }}
        value={formatDates(selectedDate)}
        onChange={handleDateChange}
      />
    </div>
    <div className='m-0'>
       <input class="form-control m-0" type="Search" placeholder="Search" id="example-search-input" 
    style={{width:"230px",borderRadius:"10px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
    </div>
         </div>
      
     </div>
      <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll', marginTop:"5px" }}>
     <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"95%",margin:"auto"}}>
  <thead>
  <tr style={{ fontWeight: 'bold' }}>
                  <th style={{ textAlign: 'left' }}>S.No</th>
                  <th style={{ textAlign: 'left' }}>Customer Name</th>
                  <th style={{ textAlign: 'left' }}>Mobile</th>
                  <th style={{ textAlign: 'left' }}>Order Id</th>
                  {/* <th style={{ textAlign: 'left' }}>Order Date</th> */}
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Order Date</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Delivered Address</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Delivery Person</th>
                  <th style={{ textAlign: 'left' }}>Amount</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Payment Status</th>
                  <th style={{ textTransform: "capitalize", textAlign: "left" }} scope="col">Refund Status</th>
                  <th style={{ textAlign: 'left' }}>Approval Status</th>
                  <th style={{ textAlign: 'left' }}>Order Status</th>
                  <th style={{ textAlign: 'left' }}>Reject Remarks</th>
                  <th style={{ textAlign: 'left' }}>View</th>

                </tr>
  </thead>
  {loading ? (
        <div className="loader-containeru">
      	  <div className="spinneru"></div>
        </div>
  ) : 
  <tbody class="body-half-screen">
                  {currentItems.length > 0 ? (
                    currentItems.map((order, index) => (
                      <tr>
                        <th scope="row">{index + 1}</th>
                        <td>{order.customer_name}</td>
                        <td>{order.mobile_no}</td>
                        <td>{order.order_no}</td>
                        <td>{order.order_date}</td>
                        <td>{order.delivery_address}</td>
                        <td style={{ textTransform: "capitalize", textAlign: "left", display: "flex", alignItems: "center", gap: "10px",borderBottom:'none' }}>
                        
                          <img
                            src={order.delivery_person_profile ? `${image_api}/${order.delivery_person_profile}` : DefaultProfileImage}
                            alt="profile"
                            width="65px"
                            height="60px"
                            style={{ borderRadius: "8px", objectFit: "cover" }}
                          />
                            <div>
                            {order.delivery_person_name || "-"}
                          </div>
                        </td>
                        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
                          ${order.amount || "-"}
                        </td>

                        <td style={{
                          textAlign: "left",
                          color: order.payment_status === 0 ? "red" : "green",
                          fontWeight: "bold"
                        }}>
                          {order.payment_status === 0 ? "Not Paid" : "Paid"}

                        </td>
                        <td style={{ textTransform: "capitalize", textAlign: "left" }}>
                          {order.is_refund === 1 ? (
                            <span style={{ color: "green", fontSize: "15px", fontWeight: 'bold' }}>
                              Refunded
                            </span>
                          ) : (
                            <span style={{ color: "orange", fontSize: "15px", fontWeight: 'bold' }}>
                               Not Refunded
                            </span>
                          )}
                        </td>
                      
                        <td>
  {(() => {
    const { text, color } = getStatusDetails(order.approval_status);
    return <h6 style={{ color , fontWeight:'bold'}}>{text}</h6>;
  })()}
</td>
<td style={{
                          textAlign: "left",
                          color: order.order_status === 0 ? "blue" :
                          order.order_status === 1 ? "orange" :
                          order.order_status === 2 ? "green" :
                          order.order_status === 3 ? "red" : "gray",
                          fontWeight: "bold",
                        }}>
                         {order.order_status === 0 ? "New" :
                         order.order_status === 1 ? "Partial" :
                         order.order_status === 2 ? "Delivered" :
                         order.order_status === 4 ? "Cancelled" : "Cancelled"}
                         </td>
<td style={{ textTransform: "capitalize", textAlign: "left" }}>
                          {order.reject_remarks || "-"}
                        </td>
                        <td>
          <div style={{ textAlign: "left", display: "flex", gap: "2px" }}>
            <button
              className="btn btn-primary"
              onClick={() => {
                handleshow(order.booking_dates,order.id);
                handelOrderNo(order);
              }}
                            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <i style={{ color: "white", fontSize: "13px" }} className="bi bi-eye-fill"></i>
            </button>
            </div>
            </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="20" style={{ textAlign: "center", color: "red", fontWeight: "bold", borderColor: "black" }}>
                        No Orders Found
                      </td>
                    </tr>
                  )}
        
 

   </tbody>
}
</table>
<Pagination
        activePage={currentPage}
        itemsCountPerPage={itemsPerPage}
        totalItemsCount={totalItems}
        pageRangeDisplayed={5}
        onChange={handlePageChange}
        itemClass="page-item"
        linkClass="page-link"
        innerClass="pagination justify-content-end"
        activeClass="active-pagination"
      />
      </div>
      

</div>
        </div>
      
      </div>

      <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
      >
        <Modal.Header style={{padding:"3px", backgroundColor:"green"}}>
          <Modal.Title style={{ fontSize:"20px"}}></Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px"}}>
         {/* <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM !</h4> */}
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Order Item 
          <span style={{color:"red",textTransform:"uppercase"}}> {EmployeeD.employee_name}</span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseConfirmation}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>


      <Modal
  show={itempopup}
  onHide={() => setItempopup(false)}
  backdrop="static"
  keyboard={false}
  size="xl"
>
  <Modal.Header closeButton>
    <Modal.Title>Delivery Dates (Order No - {orderNo})</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {/* Bill-Like List Design */}
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
        <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Date</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Slot Name</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">From Time</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">To Time</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Delivery Person</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Status</th>

          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">View List</th>


        </tr>
      </thead>
      <tbody >
  {bookingOrder.length > 0 ? (
        (() => {
          let serialCounter = 1; // Initialize counter for Serial No
          return bookingOrder.map((dateItem, dateIndex) =>
      dateItem.slots.length > 0 ? (
        dateItem.slots.map((slot, slotIndex) => (
          <tr key={`${dateIndex}-${slotIndex}`} style={{borderBottom:"0.5px solid black"}}>
       
            <td>{serialCounter++}</td>
            <td>{dateItem.date}</td>
            <td>{slot.slot_name}</td>
            <td>{slot.from_time}</td>
            <td>{slot.to_time}</td>
            <td
 style={{
  textAlign: "center",
  display: "flex",
  borderTop: "none",
  borderBottom: "none",
  alignItems:'center',

  gap: "20px",
  alignContent: "center",
  // marginTop: "11px",
  height: "100px",
}}
>
  {slot.slot_delivery_person_name ? (
    <>
      {slot.slot_delivery_person_profile && (
        <img
          src={profile}
          alt="profile"
          style={{
            width: "30px",
            height: "30px",
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      )}
      {slot.slot_delivery_person_name}
    </>
  ) : (
    "-"
  )}
</td>
            <td style={{
          textAlign: "left",
          color: slot.slot_status === 0 ? "blue" :
          slot.slot_status === 1 ? "orange" :
          slot.slot_status === 2 ? "green" :
          slot.slot_status === 3 ? "red" : "gray",
          fontWeight: "bold",
        }}>
          {slot.slot_status === 0 ? "New" :
           slot.slot_status === 1 ? "Inprogress" :
           slot.slot_status === 2 ? "Packed" :
           slot.slot_status === 3 ? "Delivered" : "Cancelled"}
        </td>
            <td>
              <button className="btn btn-primary" onClick={() => handleshowItems(slot.order_items)}>
                <i style={{ color: "white", fontSize: "13px" }} className="bi bi-eye-fill"></i>
              </button>
            </td>

          </tr>
        ))
      ) : (
        <tr key={dateIndex}>
          <td colSpan="6" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
            No data available
          </td>
        </tr>
      )
    );
  })()
  ) : (
    <tr>
      <td colSpan="10" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
        No data available
      </td>
    </tr>
  )}
</tbody>

    </Table>
    {/* <button
      className="btn btn-danger"
      onClick={() => setItempopup(false)}
      style={{ borderRadius: "15px", float: "right", marginTop: "-1px" }}
    >
      Cancel
    </button> */}
  </Modal.Body>
</Modal>

<Modal
  show={setOrdereditempopup}
  onHide={() => setOrderedItempopup(false)}
  backdrop="dynamic"
  keyboard={false}
  size="lg"
  fullscreen="sm-down" // Makes it responsive for small devices
  style={{ bottom: "0", marginTop: "auto" }} // Adjusts position
>
  <Modal.Header closeButton>
    <Modal.Title>Items</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
          <th>S.No</th>
          <th>Image</th>
          <th>Food Name</th>
          <th>Item Code</th>
          <th>Quantity</th>
          <th>Unit Price</th>
          <th>Variant Name</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        {orderedItems.length > 0 ? (
          orderedItems.map((item, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
              <td>{index + 1}</td>
              <td>
                <img
                  src={`${image_api}/${item.food_image}`}
                  alt="item_image"
                  width="50px"
                  height="50px"
                />
              </td>
              <td>{item.food_name}</td>
              <td>{item.item_code}</td>
              <td>{item.quantity}</td>
              <td>{item.unit_price}</td>
              <td>{item.variant_name}</td>
              <td>{item.remark}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="8" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
              No data available
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </Modal.Body>
</Modal>

      

            {/* </div> */}
       </Layout></>

        
    )
}

export default OrderList;